import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Logo } from "@/components/ui/Logo";

// HeroShader pulls in three.js + react-three-fiber (~700KB gzipped). It's
// used ONLY on auth pages — lazy-load so the rest of the app doesn't pay
// for it. While the shader chunk fetches, render a static gradient that
// matches the final aesthetic so there's no visual pop-in.
const HeroShader = lazy(() =>
  import("@/components/hero/HeroShader").then((m) => ({ default: m.HeroShader })),
);

export function AuthLayout() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Static fallback gradient — covers the moment before three.js loads */}
      <div
        aria-hidden
        className="absolute inset-0 z-0"
        style={{
          background:
            "radial-gradient(ellipse 60% 50% at 50% 45%, rgba(82,48,145,0.35), rgba(4,5,6,0) 70%), " +
            "radial-gradient(ellipse 50% 40% at 50% 50%, rgba(86,194,255,0.20), rgba(4,5,6,0) 75%), " +
            "var(--color-void)",
        }}
      />

      {/* Three.js animated backdrop, lazy */}
      <Suspense fallback={null}>
        <div className="absolute inset-0 z-0">
          <HeroShader />
        </div>
      </Suspense>

      {/* Content layer */}
      <div className="relative z-10 flex min-h-screen flex-col">
        <header className="px-6 pt-6 md:px-10 md:pt-10">
          <Logo />
        </header>

        <main className="flex flex-1 items-center justify-center px-6 py-10">
          <Outlet />
        </main>

        <footer className="px-6 pb-6 md:px-10 md:pb-10">
          <p className="font-mono text-[11px] tracking-[0.04em] text-[var(--color-slate-300)]">
            Built by EON · v0.1.0 · platform.eon.health
          </p>
        </footer>
      </div>
    </div>
  );
}
